// extracted by mini-css-extract-plugin
export default {"formRoot":"formclass_formRoot__UWK1Q"};